import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TouchableOpacity, View } from 'react-native';

import { Small, XSmall } from '../text';

import styles from './switch.styles';

const valueType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

class Switch extends PureComponent {

  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
      ]),
      value: valueType.isRequired,
    })).isRequired,
    labelSize: PropTypes.oneOf(['small', 'xsmall']),
    selected: valueType,
    onChange: PropTypes.func,
    align: PropTypes.oneOf(['left', 'right', 'center', 'justify']),
    width: PropTypes.number,
    isequalWidth: PropTypes.bool
  };

  static defaultProps = {
    labelSize: 'small',
    width: 250,
    align: 'center',
    isequalWidth: false,
  };

  constructor() {
    super();
    this.renderOption = this.renderOption.bind(this);
  }

  onOptionPress(pressedValue) {
    const { selected, onChange } = this.props;
    const hasChanged = pressedValue !== selected;
    if (hasChanged && onChange) {
      onChange(pressedValue);
    }
  }

  renderOption(option) {
    const { width, options, isequalWidth, messages} = this.props;
    var optionWidth = {};
    if(width && isequalWidth){
      optionWidth = { width: width / options.length};
    };
    const isSelected = option.value === this.props.selected;
    const isDisabled = option.disabled || false;
    const labelStyle = [styles.labelBase];
    const indicatorStyle = [styles.indicatorBase];
    if (isSelected) {
      labelStyle.push(styles.labelActive);
      indicatorStyle.push(styles.indicatorActive);
    }

    if (isDisabled) {
      labelStyle.push(styles.labelDisabled);
    }

    const Label = this.props.labelSize === 'xsmall' ? XSmall : Small;

    return (
      <TouchableOpacity
        key={option.value}
        testID={isSelected ? 'option-selected' : 'option'}
        onPress={() => this.onOptionPress(option.value)}
        style={[styles.option, optionWidth]}
        hitSlop={{ top: 20, bottom: 20, left: 0, right: 0 }}
        disabled={isDisabled}
      >
        <View>
          <Label style={labelStyle} testID="label">
            {(messages[option.label] != null ? messages[option.label]: option.label) || option.value}
          </Label>
          <View style={indicatorStyle} />
        </View>
      </TouchableOpacity>
    );
  }

  render() {
    const { align, width } = this.props;
    const alignmentStyle = styles[`${align}Container`];
    const containerStyles = [styles.container, alignmentStyle];
    if (align !== 'justify') {
      containerStyles.push({ width });
    }

    return (
      <View style={styles.root}>
        <View style={containerStyles} testID="switch-options">
          {this.props.options.map(this.renderOption)}
        </View>
      </View>
    );
  }
}

export default Switch;
